import React, { Component, useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Card,
  CardBody,
  CardHeader,
  CardSubtitle,
  CardText,
  CardTitle,
  Col,
  Collapse,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"

import classnames from "classnames"
import Applications from "./applications"
import Application from "services/applications/Application.service"
import Summary from "./Summary"

var appService = null

var plasticsUser = null

const tabs = props => {
  const [activeTab, setActiveTab] = useState("1")
  const [approved, setapproved] = useState()
  const [mounted, setmounted] = useState(false)

  useEffect(() => {
    appService = new Application(props.user)
    plasticsUser = appService.getStrategy("dg")
    plasticsUser.getDepartmentApprovedApplications(1).then(response => {
      if (response.status) {
        setapproved(response.data)
        setmounted(true)
      }
    })
  }, [])

  const paginate = page => {
    plasticsUser.getDepartmentApprovedApplications(page).then(response => {
      if (response.status) {
        setapproved(response.data)
      }
    })
  }

  return (
    <Col>
      {/* <Summary
        data={{
          rejected: props.statistics.rejected,
          approved: props.statistics.approved,
          processing: props.statistics.processing,
          returned: [
            { title: "Returned to Department", number: 0 }
          ],
        }}
      /> */}
      {/* <Row>
        Service Dashboards
        <a href="dashboard-director-env-audit">1. Environmental Audit Service</a>
        <br></br>
      </Row> */}
      <Card>
        <CardHeader>Department Approved Applications</CardHeader>
        <CardBody>
          {mounted ? (
            <Row>
              <Col sm="12">
                <Applications
                  data={approved}
                  user={props.user}
                  paginate={paginate}
                />
              </Col>
            </Row>
          ) : null}
        </CardBody>
      </Card>
    </Col>
  )
}

export default tabs
